import English from './en_interests.json';
import Hebrew from './he_interests.json';
import Full from "./interests_full.json";

const tripInterests = { English, Hebrew, Full };
export default tripInterests;
